export function getTailwindCSSVariable(variableName: string): string | null {
  const root = document.querySelector(':root');
  if (!root) {
    console.warn('Root element not found');
    return null;
  }
  const formattedVariableName = variableName.startsWith('--')
    ? variableName
    : `--${variableName}`;

  const value = getComputedStyle(root)
    .getPropertyValue(formattedVariableName)
    .trim();

  return value;
}
